import React from "react";
import moment from "moment";

import { useSelector } from "react-redux";
import { FaAngleLeft } from "react-icons/fa";
import { useNavigate } from "react-router";

import { PageInfoContainer } from "./styled/mypage";
import { isWeather } from "./scheduler/component/function/common";

const PageInfo = ({ label, todayWeather = null }) => {
  const navigate = useNavigate();
  const setting = useSelector((state) => state?.user?.setting);

  return (
    <PageInfoContainer className={setting.mode}>
      <button onClick={() => navigate("/mypage")}>
        <FaAngleLeft />
      </button>
      <div className="info">
        <h3>{label}</h3>
        <div className="overview">
          {todayWeather && <span>{moment().format("YYYY년 M월 D일")}</span>}
          {todayWeather && isWeather(todayWeather, true)}
        </div>
      </div>
    </PageInfoContainer>
  );
};

export default PageInfo;
